import api from "./api";

/**
 * Server-side Forte charge. The browser sends only the one-time token
 * and non-authoritative order identifiers; server validates totals and charges.
 *
 * Expected backend route: POST payments/forte/charge
 * Body fields (suggested):
 * - domain, registration_id, merchant
 * - authorization_amount, service_fee_amount
 * - billing_address { first_name, last_name, address, city, state, postal_code }
 * - card_type ("card"|"echeck")
 * - token (forte one_time_token)
 */
export const apiChargeForte = async (payload) => {
  const { data } = await api.post("payments/forte/charge", payload);
  return data;
};

/**
 * Optional: server-side Stax charge/tokenization placeholder.
 * Not wired yet; existing client flow remains for Stax.
 */
export const apiChargeStax = async (payload) => {
  const { data } = await api.post("payments/stax/charge", payload);
  return data;
};

export default {
  apiChargeForte,
  apiChargeStax,
};
